import { RootState } from '../../../store';

export const selectUser = (state: RootState) => state.auth.user;
export const selectNotifications = (state: RootState) => state.auth.notifications;
